import { InstructionCategory, Status } from 'modules/case-tracking/types/filtering/filtering.enums';
import { caseStatus } from './caseStatus';
import { IDropdownItem } from '@sanlam-glacier/app-common/components';
import { stageText } from './stageText';
import { Stage } from 'modules/case-tracking/types/case-tracking.enums';

// Get the stage connected to the respective status
export function getStage(status: Status): string {
  const result: Stage[] = [];

  for (const category in caseStatus) {
    const stageRecord = caseStatus[category as InstructionCategory];
    for (const stage in stageRecord) {
      const statusList = stageRecord[stage as Stage];
      if (statusList.includes(status)) {
        result.push(stage as Stage);
      }
    }
  }

  return result[0] ? stageText(result[0]) : 'Unknown';
}

// Order stages from 1 to 4
const sortStages = (stages: Stage[]): Stage[] => {
  const stageOrder: Stage[] = [
    Stage.Stage1,
    Stage.Stage2,
    Stage.Stage3,
    Stage.Stage4,
    Stage.Cancelled
  ];

  return stages.slice().sort((a, b) => {
    return stageOrder.indexOf(a) - stageOrder.indexOf(b);
  });
};

export const updateStatusOptions = (
  categories: InstructionCategory[],
  stages: Stage[],
  allStatus: Status[]
): IDropdownItem[] => {
  const categorySelected = categories.length > 0;
  const stageSelected = stages.length > 0;
  const orderedStages = sortStages(stages);

  // Show all if no category or stage selection
  if (!categorySelected && !stageSelected) {
    return allStatus.map((item) => ({
      value: item,
      content: item,
      subTitle: getStage(item)
    }));
  }

  const availableStatus = new Set<Status>();

  // Both category selection and stage selection
  if (categorySelected && stageSelected) {
    categories.forEach((category) => {
      orderedStages.forEach((stage) => {
        caseStatus[category]?.[stage]?.forEach((status) => availableStatus.add(status));
      });
    });
    const statusses = Array.from(availableStatus);
    return statusses.map((item) => ({
      value: item,
      content: item,
      subTitle: getStage(item)
    }));
  }

  // Only a category selection
  if (categorySelected && !stageSelected) {
    categories.forEach((category) => {
      Object.values(Stage).forEach((stage) => {
        caseStatus[category]?.[stage]?.forEach((status) => availableStatus.add(status));
      });
    });
    const statusses = Array.from(availableStatus);
    return statusses.map((item) => ({
      value: item,
      content: item,
      subTitle: getStage(item)
    }));
  }

  // Only a stage selection
  if (stageSelected && !categorySelected) {
    Object.values(InstructionCategory).forEach((category) => {
      orderedStages.forEach((stage) => {
        caseStatus[category]?.[stage]?.forEach((status) => availableStatus.add(status));
      });
    });
    const statusses = Array.from(availableStatus);
    return statusses.map((item) => ({
      value: item,
      content: item,
      subTitle: getStage(item)
    }));
  }
  return [];
};
